var map = {
	"./auth2.svg": 1515,
	"./browser.svg": 1516,
	"./control.svg": 1517,
	"./device.svg": 1518,
	"./health.svg": 1519,
	"./impersonate.svg": 1520,
	"./leak.svg": 1521,
	"./limit-access.svg": 1522,
	"./log.svg": 1523,
	"./manage-acc.svg": 1524,
	"./manage-security.svg": 1525,
	"./manage-user.svg": 1526,
	"./manage.svg": 1527,
	"./mfa.svg": 1528,
	"./otp.svg": 1529,
	"./pam.svg": 1530,
	"./prevent.svg": 1531,
	"./protocol.svg": 1532,
	"./record.svg": 1533,
	"./reports.svg": 1534,
	"./users.svg": 1535,
	"./web.svg": 1536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2543;